import * as React from 'react';

import { Cell } from 'fixed-data-table-2';
import { Binding } from 'core/infrastructure';
import { DataGridColumn, applyColumnFormat } from './DataGrid.Column';


interface DefaultCellProps extends React.HTMLProps<any> {
	disableFocus?: boolean;
	rowIndex: number;
	formattedContent: string;
	url: Nullable<string>;
	onKeyDown?: (e: React.KeyboardEvent<any>) => void;
}

interface CellProps {
	tabIndex?: number;
	onKeyDown: (e: any) => void;
	className?: string;
}

// Este componente existe únicamente para optimizar el renderizado
class DefaultCell extends React.Component<DefaultCellProps, EmptyState> {

	shouldComponentUpdate(nextProps: DefaultCellProps) {
		const hasChildren = !!nextProps.children || !!this.props.children;
		return this.props.formattedContent !== nextProps.formattedContent || hasChildren;
	}

	render() {
		const props: CellProps = {
			tabIndex: 0,
			onKeyDown: (e: any) => {
				this.props.onKeyDown?.(e);
			},
			className: this.props.className
		};

		if (this.props.disableFocus)
			delete props.tabIndex;

		const content = this.props.formattedContent.split('\n')
			.map(x => x.trim())
			.map((x, idx) =>
				<div className='cell-line' key={idx}>
					{this.props.url
						? <a className='link' href={this.props.url} target='_blank' rel="noreferrer">{x}</a>
						: x}
				</div>);

		return <Cell {...props} title={this.props.formattedContent} >{content} {this.props.children}</Cell>;
	}
}

export interface CreateCellParams<T> {
	column: DataGridColumn<T>;
	isLastColumn: boolean;
	items: T[];
	onKeyDown?: (e: React.KeyboardEvent<any>) => void;
	disableFocus?: boolean;
}

export function createCell<T>(params: CreateCellParams<T>) {
	return function Cell({ rowIndex }: any) {
		const item = params.items[rowIndex];

		if (item == null)
			return <></>;

		const content = Binding.getValue(item, Binding.propertyPathToString(params.column.linkTo));
		const children = params.column.cellChildren ? params.column.cellChildren(content, item) : [];
		const formattedContent = applyColumnFormat(params.column, content, item);
		const url = params.column.href ? params.column.href(content, item) : null;

		let className = params.isLastColumn ? 'last-row-cell' : '';
		if (params.column.cellClassName)
			className += ' ' + params.column.cellClassName;

		return <DefaultCell className={className} formattedContent={formattedContent} onKeyDown={params.onKeyDown} rowIndex={rowIndex} disableFocus={params.disableFocus} url={url}>{children}</DefaultCell>;
	};
}
